<app-header *ngIf="!isLoaded; else mainContent" (isShowSidebar)="sidenav.toggle($event)" [isMenuOpened]="isShowSidebar"></app-header>

<div [ngStyle]="{'background-color': _appsService.projectColorCode ? _appsService.projectColorCode : (_appsService.companyColorCode ? _appsService.companyColorCode : '#ffffff' )}" style="position: absolute; top: 0; left: 0; width:48px; height: 70px; z-index: 5; display: flex; align-items: center; justify-content: center;">
  <button
    type="button"
    id="tutorial-hamburger-menu"
    mat-icon-button
    (click)="toggleSidenav()"
    style="padding: 0; width: 50%; height: 50%; cursor: pointer; min-width: 0; display: flex; align-items: center; justify-content: center;"
  >
    <mat-icon
      [ngStyle]="{'color': _appsService.projectColorCode || _appsService.companyColorCode ? '#ffffff' : '#777777'}"
      style="font-size: 36px; width: 100%; height: 100%; cursor:pointer;"
    >
      menu
    </mat-icon>
  </button>
</div>

<div class="router-class" *ngIf="!isLoaded">

  <router-outlet></router-outlet>
</div>
<app-sidemenu style="z-index: 3;" [isSidenavOpened]="isSidenavOpened" (sideMenuState)="onSideMenuStateChange($event)" *ngIf="!isLoaded"></app-sidemenu>




<ng-template #mainContent>
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>


